import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"

// components
import Labels from "./labels/Labels";
import Separator from "../../../components/Separator";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";

// labels
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {PH_BACKGROUND, PH_CODE, PH_DESCRIPTION, PH_TITLE} from "../../../components/i18n/placeHolders"
import {LB_CODE, LB_STATUS, REQUIRED, LB_TITLE, LB_DESCRIPTION, LB_BACKGROUND} from "../../../components/i18n/i18n"

// services
import {pageService} from "../../../jwt/_services/landings/pageService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import Sections from "./sections/Sections";




const PageForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, app, editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app

    const [status, setStatus] = useState(!!domainObject?.status);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        title: Yup.string().required( REQUIRED ),
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            title: domainObject?.title,
            description: domainObject?.description,
            background: domainObject?.background,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                status
            }
        };

        if (!editMode)
            genericIndexedActions.save(path, pageService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, pageService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={`${editMode ? 'card-modal-big': 'card-modal'}`}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                            {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_TITLE}</Label>
                            <Input
                                type="text"
                                name="title"
                                placeholder={PH_TITLE}
                                innerRef={register}
                            />
                            { errors.title && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.title?.message}</div>}
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label>{LB_BACKGROUND}</Label>
                            <Input
                                type="text"
                                name="background"
                                placeholder={PH_BACKGROUND}
                                innerRef={register}
                            />
                            { errors.background && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.background?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{LB_STATUS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_DESCRIPTION}</Label>
                            <Input
                                type="textarea"
                                name="description"
                                placeholder={PH_DESCRIPTION}
                                innerRef={register}
                            />
                            { errors.description && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.description?.message}</div>}
                        </FormGroup>
                    </Col>
                </Row>
                {
                    editMode && <Row>
                        <Col>
                            <Labels path={props.path} />
                        </Col>
                        <Col>
                            <Sections path={props.path} />
                        </Col>
                    </Row>
                }
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default PageForm